import { useState, useEffect } from 'react';
import { useServiceWithAuth } from '@/hooks/useServiceWithAuth';
import { GroupsService, type PatientGroup } from '@/services/features/GroupsService';

export const usePatientGroups = () => {
  const [patientGroups, setPatientGroups] = useState<PatientGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const service = useServiceWithAuth(GroupsService);

  const fetchPatientGroups = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const result = await service.fetchPatientGroupDashboard();

      if (result?.data?.pep_vw_patient_group_dashboard) {
        // Show all groups (both archived and active)
        setPatientGroups(result.data.pep_vw_patient_group_dashboard);
      } else {
        setPatientGroups([]);
      }
    } catch (err) {
      console.error('Error fetching patient groups:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch patient groups');
      setPatientGroups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatientGroups();
  }, [service]);

  return { patientGroups, loading, error, refetch: fetchPatientGroups };
};
